export default __webpack_public_path__ + "static/media/network.84599993.png";